import SEO from "../../../../src/components/Seo";
import WineQuery from "../../../../src/components/WineQuery";
import * as React from 'react';
export default {
  SEO,
  WineQuery,
  React
};